var _a;
export var RU = 1;
export var EN = 5;
export var UZ = 13;
export var KK = 2;
export var DEFAULT_LANGUAGE_ID = RU;
export var SUPPORTED_LANGUAGE_IDS = [RU, EN, UZ, KK];
/** Browser language codes used only for auto-detect (not written to localStorage). */
export var BROWSER_LANGUAGE_MAP = {
    ru: RU,
    en: EN
};
export var languageMap = (_a = {},
    _a[RU] = { name: "ru", id: RU },
    _a[EN] = { name: "en", id: EN },
    _a[UZ] = { name: "uz", id: UZ },
    _a[KK] = { name: "kk", id: KK },
    _a);
export var getSavedLanguageId = function () {
    try {
        if (typeof localStorage === "undefined") {
            return null;
        }
        var saved = localStorage.getItem("languageId");
        if (saved === null) {
            return null;
        }
        var languageId = parseInt(saved, 10);
        if (!SUPPORTED_LANGUAGE_IDS.includes(languageId)) {
            return null;
        }
        return languageId;
    }
    catch (e) {
        return null;
    }
};
export var getBrowserLanguageId = function () {
    try {
        if (typeof navigator === "undefined") {
            return null;
        }
        var languages = navigator.languages || [navigator.language];
        if (!Array.isArray(languages)) {
            return null;
        }
        for (var i = 0; i < languages.length; i++) {
            var lang = languages[i];
            if (!lang || typeof lang !== "string") {
                continue;
            }
            var primary = lang.toLowerCase().split("-")[0];
            if (BROWSER_LANGUAGE_MAP[primary] != null) {
                return BROWSER_LANGUAGE_MAP[primary];
            }
        }
        return null;
    }
    catch (e) {
        return null;
    }
};
export var resolveLanguageId = function () {
    var savedLanguageId = getSavedLanguageId();
    if (savedLanguageId != null) {
        return savedLanguageId;
    }
    var browserLanguageId = getBrowserLanguageId();
    if (browserLanguageId != null) {
        return browserLanguageId;
    }
    return DEFAULT_LANGUAGE_ID;
};
export var getLanguageType = function (languageId) {
    var lang = languageId || Number(localStorage.getItem('languageId'));
    switch (lang) {
        case EN:
            return languageMap[EN];
        case UZ:
            return languageMap[UZ];
        case KK:
            return languageMap[KK];
        default:
            return languageMap[RU];
    }
};



// WEBPACK FOOTER //
// ./src/constants/Language.js